var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.value),function(item,index){return _c('div',{key:index},[_vm._v("\n    "+_vm._s(item)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }